import { Box, Card, Divider, List, ListItem } from "@mui/material";
import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { default as api, default as Api } from "../API/api";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import CheckBoxComponent from "../CommonComponent/Inputs/CheckBoxComponent";
import FileComponent from "../CommonComponent/Inputs/FileComponent";
import RadioComponent from "../CommonComponent/Inputs/RadioComponent";
import SelectComponent from "../CommonComponent/Inputs/SelectComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import MarketingConsentFormModal from "../CommonComponent/Modal/MarketingConsentFormModal";
import PrivacyPolicyModal from "../CommonComponent/Modal/PrivacyPolicyModal";
import PublicModal from "../CommonComponent/Modal/PublicModal";
import TermsOfServiceAgreement from "../CommonComponent/Modal/TermsOfServiceAgreementModal";
import "../CSS/PageCSS/CustomerQuestionPage.css";
import EXModal from "../CommonComponent/Modal/EXModal";

const { Title } = Typography;
const sexMenu: any = [
  {
    id: 1,
    name: "Men",
  },
  {
    id: 2,
    name: "Women",
  },
];
const languageMenu: any = [
  {
    p_id: 1,
    name: "Korean",
  },
  {
    p_id: 2,
    name: "English",
  },
  {
    p_id: 3,
    name: "Japanese",
  },
  {
    p_id: 4,
    name: "Chinese (Simplified)",
  },
  {
    p_id: 5,
    name: "Chinese (Traditional)",
  },
];

export default function CustomerQuestionPage() {
  let navigate = useNavigate();
  const [questionData, setQuestionData] = useState<any>();
  const [answerListData, setAnswerListData] = useState<any>([]);
  const [numberQuestionList, setNumberQuestionList] = useState<any>([]);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [customerData, setCustomerData] = useState({
    name: "",
    age: 0,
    country: 1,
    sex: 1,
    agree_01: 0,
    agree_02: 0,
    agree_03: 0,
    language: 1,
    email: "",
  });
  const [countrydata, setCountryData] = useState([]);
  const [modalAgreement, setModalAgreement] = useState(false);
  const [modalPrivacyAcceptedt, setModalPrivacyAccepted] = useState(false);
  const [modalMarketingAccepted, setModalMarketingAccepted] = useState(false);
  const [publicModal, setPublicModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [exModal, setExModal] = useState({
    value: false,
    p_id: 0,
  });

  const upload = (value: any, index: any) => {
    let copiedItems = [...answerListData];
    copiedItems[index].files = [...copiedItems[index].files, ...value];
    setAnswerListData(copiedItems);
  };

  const onDelete = (index: any, index2: any) => {
    let copiedItems = [...answerListData];
    copiedItems[index2].files.splice(index, 1);
    setAnswerListData(copiedItems);
  };

  const handleSave = () => {
    const getInsert = async () => {
      setLoading(true);
      const formData = new FormData();

      let array: {
        question_id: any;
        questiontype_id: any;
        files: never[];
        multi: number;
        answer: any;
      }[] = [];

      answerListData.map((item: any) => {
        if (item.multi == 1) {
          item.answer
            .filter((items: any) => items.use)
            .map((item2: any) => {
              const newItem = {
                question_id: item.question_id,
                questiontype_id: item.questiontype_id,
                files: [],
                multi: 0,
                answer: item2.answer,
              };

              array.push(newItem);
            });
        } else {
          array.push(item);
        }
      });

      formData.append("name", customerData.name);
      formData.append("age", customerData.age.toString());
      formData.append("country", customerData.country.toString());
      formData.append(
        "sex",
        sexMenu.filter((item: any) => customerData.sex == item.id)[0].name
      );
      formData.append("agree_01", customerData.agree_01.toString());
      formData.append("agree_02", customerData.agree_02.toString());
      formData.append("agree_03", customerData.agree_03.toString());
      formData.append("email", customerData.email);
      formData.append("answerListData", JSON.stringify(array));

      for (let i = 0; i < answerListData.length; i++) {
        for (let j = 0; j < answerListData[i].files.length; j++) {
          formData.append("files", answerListData[i].files[j]);
        }
      }

      const register = await Api.postfile(`/Customer/insertCustomer`, formData);
      setLoading(false);
      if (register != undefined) {
        setPublicModal(true);
      } else {
        setAlert(true);
        setAlertMessage("제출에 실패하였습니다.");
      }
    };

    if (
      customerData.name == "" ||
      customerData.age == 0 ||
      customerData.country == 1 ||
      customerData.sex == 0 ||
      customerData.agree_01 == 0 ||
      customerData.agree_02 == 0
    ) {
      setAlert(true);
      setAlertMessage("모든 값을 채워주세요.");
    } else {
      getInsert();
    }
  };

  const changeTextField = (value: any, index: any) => {
    if (value.name == "answer") {
      let copiedItems = [...answerListData];
      copiedItems[index].answer = value.value;
      setAnswerListData(copiedItems);
    } else if (value.name == "name") {
      setCustomerData({
        ...customerData,
        name: value.value,
      });
    } else if (value.name == "age") {
      setCustomerData({
        ...customerData,
        age: value.value,
      });
    } else if (value.name == "email") {
      setCustomerData({
        ...customerData,
        email: value.value,
      });
    }
  };

  const changeRadioField = (value: any, index: any) => {
    if (value.name == "answer") {
      let copiedItems = [...answerListData];
      copiedItems[index].answer = value.value;
      setAnswerListData(copiedItems);
    } else if (value.name == "sex") {
      setCustomerData({
        ...customerData,
        sex: value.value,
      });
    }
  };

  const changeSelect = (value: any) => {
    if (value.name == "country") {
      setCustomerData((prev: any) => ({
        ...prev,
        country: value.value,
      }));
    } else if (value.name == "language") {
      setCustomerData((prev: any) => ({
        ...prev,
        language: value.value,
      }));

      const getData = async () => {
        setLoading(true);
        const country = await api.get(`/Customer/getCountryList`);
        const question = await api.get(
          `/Question/getQuestionList?language=${value.value}`
        );
        const number = await api.get(
          `/Question/getNumberQuestion?language=${value.value}`
        );
        setLoading(false);
        if (
          country != undefined ||
          question != undefined ||
          number != undefined
        ) {
          setCountryData(country);
          setQuestionData(question);
          setNumberQuestionList(number);
          let array: { question_id: any; answer: any }[] = [];

          question.map((item: any) => {
            const newItem = {
              question_id: item.p_id,
              questiontype_id: item.questiontype_id,
              answer:
                item.multi == 1
                  ? number
                      .filter((items: any) => items.question_id == item.p_id)
                      .map((numbers: any) => {
                        const newItem = {
                          answer: numbers.NumberQuestion,
                          use: false,
                        };

                        return newItem;
                      })
                  : "",
              files: [],
              multi: item.multi,
            };

            array.push(newItem);
          });
          setAnswerListData(array);
        } else {
          setAlert(true);
          setAlertMessage("데이터 조회에 실패하였습니다.");
        }
      };
      getData();
    }
  };

  const changeCheck = (value: any, index?: any, indexs?: any) => {
    if (value.target.name == "agree_01") {
      setCustomerData((prev: any) => ({
        ...prev,
        agree_01: value.target.checked == true ? 1 : 0,
      }));
    } else if (value.target.name == "agree_02") {
      setCustomerData((prev: any) => ({
        ...prev,
        agree_02: value.target.checked == true ? 1 : 0,
      }));
    } else if (value.target.name == "agree_03") {
      setCustomerData((prev: any) => ({
        ...prev,
        agree_03: value.target.checked == true ? 1 : 0,
      }));
    } else if (value.target.name == "numberquestion") {
      let copiedItems = [...answerListData];
      copiedItems[index].answer[indexs].use = value.target.checked;
      setAnswerListData(copiedItems);
    }
  };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const country = await api.get(`/Customer/getCountryList`);
      const question = await api.get(
        `/Question/getQuestionList?language=${customerData.language}`
      );
      const number = await api.get(
        `/Question/getNumberQuestion?language=${customerData.language}`
      );
      setLoading(false);
      if (
        country != undefined ||
        question != undefined ||
        number != undefined
      ) {
        setCountryData(country);
        setQuestionData(question);
        setNumberQuestionList(number);
        let array: { question_id: any; answer: any }[] = [];

        question.map((item: any) => {
          const newItem = {
            question_id: item.p_id,
            questiontype_id: item.questiontype_id,
            answer:
              item.multi == 1
                ? number
                    .filter((items: any) => items.question_id == item.p_id)
                    .map((numbers: any) => {
                      const newItem = {
                        answer: numbers.NumberQuestion,
                        use: false,
                      };

                      return newItem;
                    })
                : "",
            files: [],
            multi: item.multi,
          };

          array.push(newItem);
        });
        setAnswerListData(array);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getData();
  }, []);

  return (
    <Box className="CustomerQuestionContainer">
      <Card variant="outlined" className="CustomerQuestionCard">
        <div
          style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}
        >
          <div style={{ display: "flex", width: "250px" }}>
            <Title level={5} className="CustomerQuestionTitle">
              Language
            </Title>
            <SelectComponent
              variant="standard"
              value={customerData.language}
              label={"language"}
              name="language"
              menulist={languageMenu}
              menuvalue="name"
              onChange={changeSelect}
              fullWidth
            />
          </div>
        </div>
        <Title level={2} className="CustomerQuestionTitle">
          CustomerQuestionPage
        </Title>
        <Title level={5} className="CustomerQuestionTitle">
          {customerData.language == 1
            ? "컨설팅 이전에 작성 완료 부탁드립니다"
            : customerData.language == 2
            ? "Please complete the form before consulting."
            : customerData.language == 3
            ? "コンサルティング前に作成完了をお願いします"
            : customerData.language == 4
            ? "咨询前请填写表格。"
            : customerData.language == 5
            ? "諮詢前請填寫表格。"
            : ""}
        </Title>
        <Divider />
        <List>
          <Title level={4} className="CustomerQuestionTitle">
            {customerData.language == 1
              ? "* 고객정보(필수)"
              : customerData.language == 2
              ? "* Customer information(Essential)"
              : customerData.language == 3
              ? "* 顧客情報(必須, 必要, 須要.)"
              : customerData.language == 4
              ? "* 客户信息(必修 。)"
              : customerData.language == 5
              ? "* 客戶資訊(必備)"
              : ""}
          </Title>
          <ListItem disablePadding className="ConsultQuestionList">
            <Title level={5} className="CustomerQuestionTitle">
              {customerData.language == 1
                ? "이름"
                : customerData.language == 2
                ? "Name"
                : customerData.language == 3
                ? "名前"
                : customerData.language == 4
                ? "姓名"
                : customerData.language == 5
                ? "姓名"
                : ""}
            </Title>
            <TextComponent
              variant="standard"
              value={customerData.name}
              name="name"
              fullWidth
              onChange={(value: any) => changeTextField(value, 0)}
            />
          </ListItem>
          <ListItem disablePadding className="ConsultQuestionList">
            <Title level={5} className="CustomerQuestionTitle">
              {customerData.language == 1
                ? "성별"
                : customerData.language == 2
                ? "Gender"
                : customerData.language == 3
                ? "性別."
                : customerData.language == 4
                ? "性别"
                : customerData.language == 5
                ? "性別"
                : ""}
            </Title>
            <RadioComponent
              value={customerData.sex}
              onChange={(value: any) => changeRadioField(value, 0)}
              menulist={sexMenu}
              labelPlacement="end"
              label={"name"}
              name="sex"
            />
          </ListItem>
          <ListItem disablePadding className="ConsultQuestionList">
            <Title level={5} className="CustomerQuestionTitle">
              {customerData.language == 1
                ? "나이"
                : customerData.language == 2
                ? "Age"
                : customerData.language == 3
                ? "年齢"
                : customerData.language == 4
                ? "年龄"
                : customerData.language == 5
                ? "年齡"
                : ""}
            </Title>
            <TextComponent
              variant="standard"
              value={customerData.age}
              name="age"
              type="number"
              fullWidth
              onChange={(value: any) => changeTextField(value, 0)}
            />
          </ListItem>
          <ListItem disablePadding className="ConsultQuestionList">
            <Title level={5} className="CustomerQuestionTitle">
              {customerData.language == 1
                ? "국가"
                : customerData.language == 2
                ? "Nation"
                : customerData.language == 3
                ? "国"
                : customerData.language == 4
                ? "国家"
                : customerData.language == 5
                ? "國家"
                : ""}
            </Title>
            <SelectComponent
              variant="standard"
              value={customerData.country}
              label={"국가"}
              name="country"
              menulist={countrydata}
              menuvalue="name"
              onChange={changeSelect}
              fullWidth
            />
          </ListItem>
          <ListItem disablePadding className="ConsultQuestionList">
            <Title level={5} className="CustomerQuestionTitle">
              {customerData.language == 1
                ? "이메일(선택)"
                : customerData.language == 2
                ? "Email (select)"
                : customerData.language == 3
                ? "Eメール(選択)"
                : customerData.language == 4
                ? "电子邮件( 选择)"
                : customerData.language == 5
                ? "電子郵件( 選擇)"
                : ""}
            </Title>
            <TextComponent
              variant="standard"
              value={customerData.email}
              name="email"
              fullWidth
              onChange={(value: any) => changeTextField(value, 0)}
            />
          </ListItem>
          <Title level={4} className="CustomerQuestionTitle">
            {customerData.language == 1
              ? "* 질문사항(컨설팅 종류에 따라 작성해주세요)"
              : customerData.language == 2
              ? "* Questions(Please fill it out according to the type of consulting)"
              : customerData.language == 3
              ? "* 質問(コンサルティングの種類によって作成してください)"
              : customerData.language == 4
              ? "* 问题(请根据咨询种类填写。)"
              : customerData.language == 5
              ? "* 問題(請根據諮詢種類填寫。)"
              : ""}
          </Title>
          {questionData &&
            answerListData &&
            questionData.map((item: any, index: any) => {
              return (
                <ListItem
                  disablePadding
                  className="ConsultQuestionList"
                  key={index}
                >
                  <Title level={5} className="CustomerQuestionTitle">
                    {index + 1}.&nbsp;{item.question}
                    {item.questiontype_id == 3 ? (
                      <ButtonComponent
                        fullWidth
                        variant="contained"
                        onClick={() => {
                          setExModal({
                            value: true,
                            p_id: item.p_id,
                          });
                        }}
                        className="ConsultEXButton"
                      >
                        {customerData.language == 1
                          ? "예시보기"
                          : customerData.language == 2
                          ? "View Example"
                          : customerData.language == 3
                          ? "例示表示"
                          : customerData.language == 4
                          ? "示例"
                          : customerData.language == 5
                          ? "示例"
                          : ""}
                      </ButtonComponent>
                    ) : (
                      ""
                    )}
                  </Title>
                  {item.questiontype_id == 1 ? (
                    <TextComponent
                      variant="standard"
                      value={answerListData[index].answer}
                      name="answer"
                      fullWidth
                      onChange={(value: any) => changeTextField(value, index)}
                    />
                  ) : item.questiontype_id == 2 ? (
                    item.multi == 0 ? (
                      <RadioComponent
                        value={answerListData[index].answer}
                        onChange={(value: any) =>
                          changeRadioField(value, index)
                        }
                        menulist={numberQuestionList.filter(
                          (items: any) => items.question_id == item.p_id
                        )}
                        labelPlacement="end"
                        name="answer"
                        label={"NumberQuestion"}
                      />
                    ) : (
                      numberQuestionList
                        .filter((items: any) => items.question_id == item.p_id)
                        .map((numberquestion: any, indexs: any) => {
                          return (
                            <CheckBoxComponent
                              labelPlacement="end"
                              label={numberquestion.NumberQuestion}
                              value={answerListData[index].answer[indexs].use}
                              name="numberquestion"
                              onChange={(value) =>
                                changeCheck(value, index, indexs)
                              }
                            />
                          );
                        })
                    )
                  ) : item.questiontype_id == 3 ? (
                    <FileComponent
                      value={answerListData[index].files}
                      index={index}
                      upload={upload}
                      onDelete={onDelete}
                      accept={{ "image/*": [] }}
                      language={customerData.language}
                      maxFiles={2}
                    />
                  ) : (
                    ""
                  )}
                </ListItem>
              );
            })}
        </List>
        <Divider />
        <ListItem disablePadding className="ConsultQuestionListCheck">
          <CheckBoxComponent
            labelPlacement="end"
            label={
              customerData.language == 1
                ? "(필수) 이용약관 동의"
                : customerData.language == 2
                ? "(Required) Agree to Terms of Use"
                : customerData.language == 3
                ? "（必須）利用規約の同意"
                : customerData.language == 4
                ? "（必填）同意使用条款"
                : customerData.language == 5
                ? "（必填）同意使用條款"
                : ""
            }
            value={customerData.agree_01 == 1 ? true : false}
            name="agree_01"
            onChange={changeCheck}
          />
          <ButtonComponent
            variant="contained"
            onClick={() => setModalAgreement(true)}
            className="CustomerQuestionButtonCheck"
          >
            {customerData.language == 1
              ? "보기"
              : customerData.language == 2
              ? "Look"
              : customerData.language == 3
              ? "見る"
              : customerData.language == 4
              ? "看"
              : customerData.language == 5
              ? "看"
              : ""}
          </ButtonComponent>
        </ListItem>
        <ListItem disablePadding className="ConsultQuestionListCheck">
          <CheckBoxComponent
            labelPlacement="end"
            label={
              customerData.language == 1
                ? "(필수) 개인정보처리방침 동의"
                : customerData.language == 2
                ? "(Required) Agree to personal information processing policy"
                : customerData.language == 3
                ? "（必須）個人情報処理方針に同意する"
                : customerData.language == 4
                ? "（必填）同意个人信息处理政策"
                : customerData.language == 5
                ? "（必填）同意個人資訊處理政策"
                : ""
            }
            value={customerData.agree_02 == 1 ? true : false}
            name="agree_02"
            onChange={changeCheck}
          />
          <ButtonComponent
            variant="contained"
            onClick={() => setModalPrivacyAccepted(true)}
            className="CustomerQuestionButtonCheck"
          >
            {customerData.language == 1
              ? "보기"
              : customerData.language == 2
              ? "Look"
              : customerData.language == 3
              ? "見る"
              : customerData.language == 4
              ? "看"
              : customerData.language == 5
              ? "看"
              : ""}
          </ButtonComponent>
        </ListItem>
        <ListItem disablePadding className="ConsultQuestionListCheck">
          <CheckBoxComponent
            labelPlacement="end"
            label={
              customerData.language == 1
                ? "(선택) 마케팅정보 수신 동의"
                : customerData.language == 2
                ? "(Optional) Consent to receive marketing information"
                : customerData.language == 3
                ? "（オプション）マーケティング情報の受信に同意する"
                : customerData.language == 4
                ? "（可选）同意接收营销信息"
                : customerData.language == 5
                ? "（可選）同意接收行銷訊息"
                : ""
            }
            value={customerData.agree_03 == 1 ? true : false}
            name="agree_03"
            onChange={changeCheck}
          />
          <ButtonComponent
            variant="contained"
            onClick={() => setModalMarketingAccepted(true)}
            className="CustomerQuestionButtonCheck"
          >
            {customerData.language == 1
              ? "보기"
              : customerData.language == 2
              ? "Look"
              : customerData.language == 3
              ? "見る"
              : customerData.language == 4
              ? "看"
              : customerData.language == 5
              ? "看"
              : ""}
          </ButtonComponent>
        </ListItem>
        <ButtonComponent
          fullWidth
          variant="contained"
          onClick={() => handleSave()}
          className="CustomerQuestionButton"
        >
          {customerData.language == 1
            ? "제출"
            : customerData.language == 2
            ? "Submit"
            : customerData.language == 3
            ? "提出"
            : customerData.language == 4
            ? "提交"
            : customerData.language == 5
            ? "提交"
            : ""}
        </ButtonComponent>
      </Card>
      {modalAgreement && (
        <TermsOfServiceAgreement
          open={modalAgreement}
          onClose={(value: any) => {
            if (value) {
              setCustomerData({
                ...customerData,
                agree_01: 1,
              });
            }
            setModalAgreement(false);
          }}
          cancel={true}
          language={customerData.language}
        />
      )}
      {modalPrivacyAcceptedt && (
        <PrivacyPolicyModal
          open={modalPrivacyAcceptedt}
          onClose={(value: any) => {
            if (value) {
              setCustomerData({
                ...customerData,
                agree_02: 1,
              });
            }
            setModalPrivacyAccepted(false);
          }}
          cancel={true}
          language={customerData.language}
        />
      )}
      {modalMarketingAccepted && (
        <MarketingConsentFormModal
          open={modalMarketingAccepted}
          onClose={(value: any) => {
            if (value) {
              setCustomerData({
                ...customerData,
                agree_03: 1,
              });
            }
            setModalMarketingAccepted(false);
          }}
          cancel={true}
          language={customerData.language}
        />
      )}
      {publicModal && (
        <PublicModal
          open={publicModal}
          onClose={(value: any) => {
            navigate(0);
            setPublicModal(false);
          }}
          message={
            customerData.language == 1
              ? "제출되었습니다."
              : customerData.language == 2
              ? "has been submitted"
              : customerData.language == 3
              ? "提出されました"
              : customerData.language == 4
              ? "已提交"
              : customerData.language == 5
              ? "已提交"
              : ""
          }
        />
      )}
      {exModal.value && (
        <EXModal
          open={exModal.value}
          onClose={(value: any) => {
            setExModal({
              value: false,
              p_id: 0,
            });
          }}
          p_id={exModal.p_id}
        />
      )}
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </Box>
  );
}
